<div class="dashboard-page">

  <app-title-info [title]="dashboardTitle" [subTitle]="dashboardSubtitle"></app-title-info>
  <app-divider-line></app-divider-line>

  <div class="toolbar-area">
    <div class="left-panel-toolbar">
      <div class="d-flex align-items-center">
        <div class="project-text">Project</div>
        <app-tag [title]="totalRecords"></app-tag>
      </div>

      <mat-tab-group class="toolbar-img-tabs" (selectedTabChange)="onTileIconTabChange($event)">
        <mat-tab #firstTab>
          <ng-template mat-tab-label>
            <img matTooltip="Tile View"
              [ngSrc]="firstTab.isActive ? './assets/images/icons/tile-active.svg' : './assets/images/icons/tile.svg'"
              height="32" width="32" alt="Tile View" />
          </ng-template>
        </mat-tab>
        <mat-tab #secondTab>
          <ng-template mat-tab-label>
            <img matTooltip="List View"
              [ngSrc]="secondTab.isActive ? './assets/images/icons/list-active.svg' : './assets/images/icons/list.svg'"
              height="32" width="32" alt="List View" />
          </ng-template>
        </mat-tab>
      </mat-tab-group>

    </div>

    <div class="right-panel-toolbar">
      <mat-paginator #projectListPaginator (page)="handlePageEvent($event)"
        [ngStyle]="{ display: !secondTab.isActive ? 'none' : null }" [pageSize]="defaultPageSize"
        [pageSizeOptions]="pageSizeOptions" aria-label="Select page">
      </mat-paginator>

      <button (click)="filterDataDialog()" mat-flat-button class="filter-btn" aria-label="Filter">
        <img src="./assets/images/icons/filter.svg" alt="list view" />Filter ({{totalSelectedFilterCount}})
      </button>
      <!--Check if Platform admin accessibilty-->
      <button mat-flat-button color="primary" (click)="openCreateProjectDialog()"
        *ngIf="userService.userHasPlatformAdminRole">
        <img src="assets/images/icons/plus-icon.svg" alt="Add Project" />
        Add Project
      </button>
    </div>

  </div>

  <mat-divider></mat-divider>

  <div class="dashboard-content" *ngIf="isDataLoaded">
    <div class="tile-view-area" *ngIf="firstTab.isActive">
      <!--Tile View Needs Attention Bucket-->
      <app-project-bucket-slider *ngIf="(userService.userHasPlatformAdminRole || isLoginUserProjectAdmin)"
        expansionTitle="Needs Attention" [projects]="needAttentionProjectList"
        [totalCards]="needAttentionProjectList.length" [isPaggination]="true"></app-project-bucket-slider>
      <mat-divider *ngIf="userService.userHasPlatformAdminRole"></mat-divider>
      <!--Tile View Recently Worked Bucket-->
      <app-project-bucket-slider expansionTitle="Recently Worked On" [projects]="recentlyWorkedProjectList"
        [totalCards]="recentlyWorkedProjectList.length" [isPaggination]="true"></app-project-bucket-slider>
      <mat-divider></mat-divider>
      <!--Tile View Other Projects Bucket-->
      <app-project-bucket-slider expansionTitle="Other Projects" [projects]="otherProjectsList"
        [totalCards]="otherProjectsList.length" [isPaggination]="false"></app-project-bucket-slider>
    </div>
    <div class="list-view-area" *ngIf="secondTab.isActive">
      <!--List View Tabs-->
      <mat-tab-group #listTabGroup class="list-view-tabs" mat-stretch-tabs="false" mat-align-tabs="start"
        (selectedTabChange)="onTabChanged($event);">
        <!--List View Needs Attention Tab-->
        <mat-tab #attention *ngIf="(userService.userHasPlatformAdminRole || isLoginUserProjectAdmin)" label="attention">
          <ng-template mat-tab-label>
            <span>Needs Attention</span>
            <app-tag [title]="needAttentionProjectList.length"></app-tag>
          </ng-template>
          <div *ngIf="clickedTab==='attention'">
            <app-project-list [columns]="columnsToDisplay" [projects]="needAttentionProjectList"
              tab="projectsNeedAttention" [tabName]="tabName" [totalProjectsCount]="totalProjectsCount"
              [topPaginator]="projectListPaginator">
            </app-project-list>
          </div>
        </mat-tab>
        <!--List View Recently Worked Tab-->
        <mat-tab label="recent">
          <ng-template mat-tab-label>
            <span>Recently Worked On</span>
            <app-tag [title]="recentlyWorkedProjectList.length"></app-tag>

          </ng-template>
          <div *ngIf="clickedTab==='recent'">
            <app-project-list [columns]="columnsToDisplay" [projects]="recentlyWorkedProjectList"
              tab="recentlyWorkedProjects" [tabName]="tabName" [totalProjectsCount]="totalProjectsCount"
              [topPaginator]="projectListPaginator">
            </app-project-list>
          </div>
        </mat-tab>
        <!--List View Other Projects Tab-->
        <mat-tab label="all">
          <ng-template mat-tab-label>
            <span>Other Projects</span>
            <app-tag [title]="otherProjectsList.length"></app-tag>
            <button mat-flat-button class="filter-btn" aria-label="Sort" [matMenuTriggerFor]="sortProjectsMenu"
              (click)="$event.stopPropagation()" *ngIf="tabName==='other'">
              <img src="./assets/images/icons/sort.svg" alt="list view" />Sort
            </button>
            <mat-menu #sortProjectsMenu="matMenu">
              <div class="menu-icon-wrapper">
                <button mat-menu-item [ngClass]="{'active-sort-menu': selectedSort === menu.name}" *ngFor="let menu of sortProjectsMenuValue"
                  (click)="updateListViewSortValue(menu);">
                  <div class="menu-icon-list">
                    <div class="menu-icon-container">
                      <img src="assets/images/icons/sort.svg" alt="Arrow" *ngIf="(menu.id === 1 || menu.id === 2)"
                        class="menu-icon" />
                      <img src="assets/images/icons/calender.svg" alt="Arrow" *ngIf="(menu.id === 3 || menu.id === 4)"
                        class="menu-icon" />
                      <span class="vertical-dot-menu-text-font">
                        {{menu.name}}
                      </span>
                    </div>
                  </div>
                </button>
              </div>
            </mat-menu>
          </ng-template>
          <div *ngIf="clickedTab==='all'">
            <app-project-list [columns]="columnsToDisplay" [projects]="otherProjectsList" tab="otherProjects"
              [tabName]="tabName" [totalProjectsCount]="totalProjectsCount" [topPaginator]="projectListPaginator">
            </app-project-list>
          </div>
        </mat-tab>


      </mat-tab-group>
    </div>
  </div>

</div>
